import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-[#f1f8e9]" data-id="element-278">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-279">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-280">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block p-3 bg-[#4a7c2c] rounded-full mb-6" data-id="element-281">
            <BookOpen className="w-8 h-8 text-white" data-id="element-282" />
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-6" data-id="element-283">
            🌱 Por eso existe la Guía para Hacer Esquejes
          </h2>
          <p className="text-xl text-[#666666] leading-relaxed" data-id="element-284">
            Una guía clara y ordenada que te muestra qué hacer en cada etapa,
            sin dudas ni prueba y error.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-285">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-286">
            <h3 className="text-2xl font-bold text-[#2d5016]" data-id="element-287">
              Vas a aprender el método paso a paso para:
            </h3>
            <ul className="space-y-4" data-id="element-288">
              {['evitar errores comunes', 'entender el proceso completo', 'obtener resultados reales desde el primer intento'].map((item, i) => <li key={i} className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm border border-[#e8f5e9]" data-id="element-289">
                  <CheckCircle2 className="w-6 h-6 text-[#4a7c2c] shrink-0" data-id="element-290" />
                  <span className="text-lg text-[#1a1a1a]" data-id="element-291">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border border-[#e8f5e9]" data-id="element-292">
            <h3 className="text-2xl font-bold text-[#1a1a1a] mb-6" data-id="element-293">
              Con esta guía vas a saber exactamente:
            </h3>
            <ul className="space-y-6" data-id="element-294">
              {['Dónde y cómo cortar correctamente', 'Qué sustrato usar en cada caso', 'Cuándo intervenir y cuándo esperar', 'Cómo acompañar el esqueje hasta que enraíza'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-295">
                  <div className="mt-1 w-5 h-5 rounded-full bg-[#e8f5e9] flex items-center justify-center shrink-0" data-id="element-296">
                    <div className="w-2 h-2 rounded-full bg-[#4a7c2c]" data-id="element-297"></div>
                  </div>
                  <span className="text-lg text-[#666666]" data-id="element-298">{item}</span>
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-gray-100 text-center" data-id="element-299">
              <p className="text-[#4a7c2c] font-medium italic" data-id="element-300">
                Todo explicado de forma simple, práctica y pensada para personas
                reales.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}